import React from "react";

import { ListItem } from "../../../../components/Lister/Lister.d";
import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";
import { TutorredCohort } from "./UserTutors.d";

const _PROGRAM_MANAGER_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfuO-NTf-44cUUol-9GgyPWaUvVfRKBG8FTaVBlRO284XGXrg/viewform";

export const fetchUserTutors = (userId: number, setTutors: Function, setLoading: Function) => {
  setLoading((previous: any) => ({ ...previous, tutors: true }));
  ApiService.get(`users/${userId}/tutors`)
    .then((response) => setTutors(response.data.user_tutors))
    .catch((error) => console.error("An error occurred while fetching user's tutors", error))
    .finally(() => setLoading((previous: any) => ({ ...previous, tutors: false })));
};

export const fetchUserTutorredCohorts = (userId: number, setTutorredCohorts: Function, setLoading: Function) => {
  setLoading((previous: any) => ({ ...previous, cohorts: true }));
  ApiService.get(`users/${userId}/tutors/cohorts`)
    .then((response) =>
      setTutorredCohorts(
        Object.fromEntries(
          response.data.user_tutorred_cohorts.map((tutorred_cohort: TutorredCohort) => [
            tutorred_cohort.id,
            tutorred_cohort,
          ])
        )
      )
    )
    .catch((error) => console.error("An error occurred while fetching user's tutorred cohorts", error))
    .finally(() => setLoading((previous: any) => ({ ...previous, cohorts: false })));
};

export const fetchUserTutorredCohortForms = (
  userId: number,
  cohortId: number,
  setForms: Function,
  setLoading: Function
) => {
  setLoading(true);
  ApiService.get(`users/${userId}/tutors/cohorts/${cohortId}/forms`)
    .then((response) => setForms(response.data.user_tutorred_cohort_forms))
    .catch((error) => console.error("An error occurred while fetching user's tutoring forms", error))
    .finally(() => setLoading(false));
};

export const generateUserTutorredCohortFormDocument = (
  userId: number,
  cohortId: number,
  gradeType: "half" | "full",
  language: string,
  successCallback: Function,
  finalCallback: Function,
  showAlert?: Function,
  popAlert?: Function
) => {
  ApiService.post(`users/${userId}/tutors/cohorts/${cohortId}/forms/documents`, { grade_type: gradeType })
    .then(() => {
      showAlert?.({
        type: "success",
        title: translate(language, "PAGES.USER.TUTOR.FORMS.GENERATION_SUCCESS"),
        buttons: [
          {
            label: translate(language, "PAGES.USER.TUTOR.FORMS.CLOSE"),
            onClick: () => popAlert?.(),
          },
        ],
      });
      successCallback();
    })
    .catch((error: any) => {
      console.error("An error occurred while generating the tutoring form document", error);
      showAlert?.({
        type: "danger",
        title: translate(language, "PAGES.USER.TUTOR.FORMS.GENERATION_ERROR_TITLE"),
        message: error?.data?.message || translate(language, "PAGES.USER.TUTOR.FORMS.GENERATION_ERROR"),
        buttons: [
          {
            label: translate(language, "PAGES.USER.TUTOR.FORMS.CLOSE"),
            variant: "danger",
            onClick: () => popAlert?.(),
          },
        ],
        extraContent: error?.data
          ? React.createElement(
              "pre",
              { className: "text-start off-white-background p-2 rounded border" },
              JSON.stringify(error.data, null, 2)
            )
          : null,
      });
    })
    .finally(() => finalCallback());
};

export const createUserTutor = (
  userId: number,
  cohortId: number,
  tutorId: number,
  language: string,
  successCallback: Function,
  finalCallback: Function
) => {
  ApiService.post(`users/${userId}/tutors`, { cohort_id: cohortId, tutor_id: tutorId })
    .then(() => {
      alert(translate(language, "PAGES.USER.TUTOR.CREATE_MODAL.SUCCESS"));
      successCallback();
    })
    .catch((error) => {
      console.error("Error adding user tutor", error);
      alert(translate(language, "PAGES.USER.TUTOR.CREATE_MODAL.ERROR"));
    })
    .finally(() => finalCallback());
};

export const goToPMLink = () => window.open(_PROGRAM_MANAGER_URL, "_blank");

export const openMailClientForCohortLeader = (cohortLeaderEmail: string) => {
  const url = `mailto:${cohortLeaderEmail}?cc=suivi.alternance@liora.io`;
  window.location.href = url;
};

export const renderDocumentFilenames = (
  tutorred_cohort: TutorredCohort,
  cohortName: string,
  language: string
): ListItem[] => {
  const fileName = `${translate(language, "PAGES.USER.TUTOR.DOCUMENT_LIST.PRESENTATION_TITLE")} ${cohortName}`;

  const documents = tutorred_cohort.presentation_document_url.map((fileLink, index) => ({
    name: `${fileName}${tutorred_cohort.presentation_document_url.length > 1 ? ` #${index + 1}` : ""}`,
    link: fileLink,
  }));

  if (!tutorred_cohort.pedagogical_path_url) return documents;

  return [
    ...documents,
    {
      name: `${translate(language, "PAGES.USER.TUTOR.DOCUMENT_LIST.PEDAGOGICAL_PATH_TITLE")} ${cohortName}`,
      link: tutorred_cohort.pedagogical_path_url,
    },
  ];
};
